import { Module } from 'vuex'
import { getters } from './getters'
import { actions } from './actions'
import { mutations } from './mutations'
import { SetupState } from './types'
import { RootState } from '../../types'
import * as storage from '@/calendesk/tools/storage'

export const state: SetupState = {
  appConfiguration: null,
  translations: null,
  preloader: true,
  tenant: null,
  draftUuid: null,
  regulations: null,
  privacyPolicy: null,
  timeNotation: storage.local.getItem('timeNotation') || '24h',
  initialSetup: false,

  // We could call here the localStorage and get this value that's already stored:
  // storage.local.getItem('timeZone'),
  // This could bring a potential problem when a user is traveling and really is changing the timezone.
  // If should always "guess" the timezone based on the browser settings.
  defaultTimeZone: null
}

const namespaced = true

export const setup: Module<SetupState, RootState> = {
  namespaced,
  state,
  getters,
  actions,
  mutations
}
